import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import RichContent from '@components/RichContent/RichContent';
import useToggle from '@hooks/useToggle';

import { IDeactivatedSupplementMessageProps } from './DeactivatedSupplementMessage.interface';

import './style.scss';

const DeactivatedSupplementMessage: FC<IDeactivatedSupplementMessageProps> = ({ className }) => {
  const { t } = useTranslation();
  const [isExpanded, handleExpand] = useToggle();

  return (
    <div className={cn('deactivated-supplement-message', className)}>
      <div className="deactivated-supplement-message__text">
        {t('deactivatedSupplement.message')}{' '}
        {!isExpanded && (
          <span className="deactivated-supplement-message__show-more" onClick={handleExpand}>
            {t('deactivatedSupplement.showMore')}
          </span>
        )}
      </div>

      {isExpanded && (
        <RichContent className="deactivated-supplement-message__details">
          {t('deactivatedSupplement.details')}
        </RichContent>
      )}
    </div>
  );
};

export default DeactivatedSupplementMessage;
